// import { ICON_ID } from '@gerenciatd/next.components.icon';
import { providers, TITULAR, logoDisneyBlue, STATUS_TYPES } from '@/constants/constants';
import { PRODUCT_OFFERING_TYPES } from '@/constants/modulesTv';
import {
  netflixText,
  disneyText,
  daznText,
  daznTitle,
  netflixTitle,
  disneyTitle,
  NO_ACTIVATED_STATE,
  ACTIVATED_STATE,
} from '@/constants/tv';
import { getUrl } from '@/utils/commonUtils';
import {
  getDadByProductId,
  hasProviderCompatibility,
  hasProviderCompatibilityCapa,
} from "@/utils/dataHandlers/ProductDataHandler";

export const netflixTv = (listProviders, scope) => {
  const netflix = listProviders[providers.netflix];
  const upgrade = scope !== TITULAR;
  if (netflix) {
    const buttonProps = {
      link: !upgrade && netflix.urlActivationNetflix,
      label: 'Entrar',
      target: !upgrade && '_blank',
      color: 'blue',
      componentName: 'entrar-netflix-principal',
    };
    return {
      title: netflixTitle,
      img: 'https://www.movistar.es/estaticos/imagenes/app/tv/paquetes/netflix-solid.png',
      text: netflixText,
      buttonProps,
    };
  }
  return null;
};

export const disneyTvCompatible = (listProviders, urlLibrary) => {
  const disney = listProviders[providers.disneyCompativility];
  if (disney) {
    const buttonProps = {
      link: `${getUrl(
        'DisneyActivacion',
        urlLibrary
      )}?pid=PA-telco-mis-productos-television-activar-disney`,
      label: 'Activar',
      color: 'blue',
      componentName: 'activar-disney-principal',
    };
    return {
      title: disneyTitle,
      img: logoDisneyBlue,
      text: disneyText,
      buttonProps,
    };
  }
  return null;
};

export const disneyTvActive = (listProviders) => {
  const disney = listProviders[providers.disneyActivated];
  const linkUrlDisney = 'https://www.disneyplus.com/login';
  if (disney) {
    const buttonProps = {
      link: linkUrlDisney,
      label: 'Entrar',
      color: 'blue',
      componentName: 'entrar-disney-principal',
    };
    return {
      title: disneyTitle,
      img: logoDisneyBlue,
      text: disneyText,
      buttonProps,
    };
  }
  return null;
};

export const daznTv = (listProviders, urlLibrary) => {
  const dazn = listProviders[providers.dazn];
  if (dazn) {
    const buttonProps = {
      link: `${getUrl('ProviderActivacion',urlLibrary)}?partner=${providers.dazn}`,
      label: 'Entrar',
      color: 'blue',
      componentName: 'entrar-dazn-principal',
    };
    return {
      title: daznTitle,
      svgIcon: 'Dazn',
      text: daznText,
      buttonProps,
    };
  }
  return null;
};

export const getProviderTv = (listProviders, urlLibrary, scope = TITULAR) => {
  const providersTv = [];
  const disneyCompatible = disneyTvCompatible(listProviders, urlLibrary);
  if (disneyCompatible) {
    providersTv.push(disneyCompatible);
  }
  const disneyActive = disneyTvActive(listProviders);
  if (disneyActive) {
    providersTv.push(disneyActive);
  }
  const netflix = netflixTv(listProviders, scope);
  if (netflix) {
    providersTv.push(netflix);
  }
  const dazn = daznTv(listProviders, urlLibrary);
  if (dazn) {
    providersTv.push(dazn);
  }
  return providersTv;
};

export const getFeaturesToPain = (features, allfeatures) => {
  const featuresToPain = allfeatures.filter((f) =>
    features.some((feat) => f.name === feat)
  );
  return featuresToPain;
};


export const getProviderActivationDataOld = ({providerCompatibility, provider, providerStatus}) => {
  const providerCompatibilityArray =
      providerCompatibility &&
      providerCompatibility[provider] &&
      providerCompatibility[provider].compatibles;

    const providerStatusArray =
      providerStatus &&
      providerStatus[provider] &&
      providerStatus[provider].lineas;

    const hasCompability = hasProviderCompatibility(
      providerCompatibility,
      provider
    );

    let status = null;
    let url = null;
    let target = "_blank";

    const codigoPromocion =
      Array.isArray(providerStatusArray) &&
      providerStatusArray.length > 0 &&
      providerStatusArray[0].codigoPromocion;

    if (
      Array.isArray(providerCompatibilityArray) &&
      providerCompatibilityArray.length > 0 &&
      Array.isArray(providerStatusArray) &&
      providerStatusArray.length > 0 &&
      providerCompatibilityArray[0].compatibilidad
    ) {
      if (
        providerStatusArray[0].estado === "I" ||
        providerCompatibilityArray[0].estado === "I"
      ) {
        status = providerCompatibilityArray[0].addOn
          ? STATUS_TYPES.ADDON
          : STATUS_TYPES.FUSION;
        url =
          providerStatusArray &&
          providerStatusArray[0] &&
          providerStatusArray[0].url;
      } else if (
        providerStatusArray[0].estado === "A" ||
        providerCompatibilityArray[0].estado === "A"
      ) {
        status = STATUS_TYPES.ACTIVATED;
      }
    } else if (!hasCompability) {
      status = STATUS_TYPES.CONTRACT;
      url = "";
    }

    return { providerStatusArray, codigoPromocion, status, url, target }
}

export const getProviderActivationData = ({provider, providerStatus, productId}) => {
 const providerCompatibilityArray =
      providerStatus &&
      providerStatus[provider] &&
      providerStatus[provider].compatible;

    const providerStatusArray =
      providerStatus &&
      providerStatus[provider] &&
      providerStatus[provider].compatibleProducts;

    const hasCompability = hasProviderCompatibilityCapa(
      providerStatus,
      provider
    );

    let status = null;
    let url = null;
    let target = "_blank";

    const codigoPromocion =
      Array.isArray(providerStatusArray) &&
      providerStatusArray.length > 0 &&
      providerStatusArray[0].promoCode;

    if (
      Array.isArray(providerStatusArray) &&
      providerStatusArray.length > 0 &&
      providerCompatibilityArray
    ) {
      const providerByProductId = productId ? providerStatusArray.find((product) => product?.productId === productId) : providerStatusArray[0];
      if (
        providerByProductId && providerByProductId?.state === NO_ACTIVATED_STATE
      ) {
        status = providerByProductId?.addOn
          ? STATUS_TYPES.ADDON
          : STATUS_TYPES.FUSION;
        url =
          providerByProductId &&
          providerByProductId.activationUrl;
      } else if (
        providerByProductId &&
        providerByProductId.state === ACTIVATED_STATE
      ) {
        status = STATUS_TYPES.ACTIVATED;
      }
    } else if (!hasCompability) {
      status = STATUS_TYPES.CONTRACT;
      url = "";
    }

    return { providerStatusArray, codigoPromocion, status, url, target }
}

export const isCompatibleProviderByProductId = ({providerCompatibility, productId, provider}) => {
  let isCompatible = null;
  if (providerCompatibility?.[provider]?.compatibleProducts && productId) {
    const compatibleProducts = providerCompatibility?.[provider]?.compatibleProducts;
    if (compatibleProducts && Array.isArray(compatibleProducts) && compatibleProducts.length > 0) {
      isCompatible = compatibleProducts.find((product) => product?.productId === productId);
    }
  }
  return isCompatible;
}

export const removeDuplicateCardsById = (cards) => {
  const seenIds = new Set(); // Usaremos un Set para llevar un registro de los IDs que ya hemos visto.
  const uniqueCards = [];   // Aquí almacenaremos las cards únicas.

  for (const card of cards) {
    // Si el ID de la card actual NO ha sido visto antes, la añadimos a uniqueCards
    if (!seenIds.has(card.id)) {
      seenIds.add(card.id);     // Marcamos este ID como visto
      uniqueCards.push(card);   // Añadimos la card al array de únicas
    }
  }
  return uniqueCards;
};

export const hasMimoProductType = ({ userInfo, productId, hiredProducts }) => {
  if ( userInfo && userInfo?.userBundle && hiredProducts && Array.isArray(hiredProducts) && hiredProducts.length > 0 ) {
    const { userBundle } = userInfo;
    if (userBundle && Array.isArray(userBundle) && userBundle.length > 0) {
      const bundle = userBundle.find((item) => {
        const dadProduct = getDadByProductId(hiredProducts, productId);
        if (dadProduct?.productId === item?.productId) {
          return item;
        }
      });
      if (
        bundle &&
        bundle?.pot &&
        bundle?.pot.some(
          (element) =>
            element.id === PRODUCT_OFFERING_TYPES.PRODUCTS.MIMOVISTAR.ID
        )
      ) {
        return PRODUCT_OFFERING_TYPES.PRODUCTS.MIMOVISTAR.ID;
      }
    }
  }
  return null;
};

export const getProductIdProviderForGeneralManagmetPill = ({compatibleProducts, generalManagmentData, detailProduct, href}) => {
  if (detailProduct?.productId) {
    return `${href}&productId=${detailProduct?.productId}`
  } else if (compatibleProducts && Array.isArray(compatibleProducts) && compatibleProducts.length === 1 && generalManagmentData && Array.isArray(generalManagmentData) && generalManagmentData.length < 2) {
    const productId = compatibleProducts[0]?.productId
    return `${href}&productId=${productId}`
  }
  return null;
}